<script setup>

// import Swiper core and required modules
import { Navigation, Pagination, A11y } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/vue';

// Swiper modules
const modules = [Navigation, Pagination, A11y];

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/zoom';

var swiperInstance;

const onSwiper = (swiper) => {
	swiperInstance = swiper;
};

const slideTo = (index) => {
	swiperInstance.slideTo(index);
}

const discount = (price) => {
	return 100 - Math.round(price.price_new * 100 / price.price_old);
}

defineProps({
	product : Object,
})

</script>


<template>

	<div class="product-media">

		<span class="discount-label" :title="'Discount ' + discount(product.price) + '%'" v-if="product.price.price_new && product.price.price_old">-{{ discount(product.price) }}%</span>

		<swiper
			:modules="modules"
			:slides-per-view="1"
			:space-between="50"
			:pagination="{ clickable : true }"
			@swiper="onSwiper"
			@slideChange="event => { $emit('change_gallery_key', event.activeIndex) }">

			<swiper-slide v-for="(image, imageKey) in product.images">
				<img :src="'/storage/product_image' + image.name" alt="" class="product_image" @dblclick="$emit('open_gallery', imageKey)">
			</swiper-slide>

		</swiper>

		<div
			class="media-nav justify-content-center"
			v-if="product.images.length > 1"
		>
			<div class="thumbnail-holder cursor-pointer" v-for="(image, imageKey) in product.images" :key="imageKey" @click="slideTo(imageKey)">
				<img class="thumbnail" :src="'/storage/product_image' + image.name" alt="">
			</div>
		</div>


	</div>

</template>

<script>
export default {
	name: "ProductMedia",
}
</script>